import SyncPage from './SyncPage';

const exports = {
    Page: SyncPage,
};

export default exports;
export { SYNC_PATH } from './routes';
